import React from 'react';
import './TopBar.css';

export default function TopBar() {
  return (
    <div className="topbar">
      <div className="topbar-container">
        <div className="topbar-left">
          <i className="fa fa-award" />
          <span>Greater Noida's Most Trusted Real Estate Partner — BricksNHome</span>
        </div>
        <div className="topbar-right">
          <a href="tel:+917477471006" className="topbar-item">
            <i className="fa fa-phone" />
            <span>+91 7477-471-006</span>
          </a>
          <span className="topbar-divider" />
          <a href="mailto:info@bricksnhome.com" className="topbar-item">
            <i className="fa fa-envelope" />
            <span>info@bricksnhome.com</span>
          </a>
        </div>
      </div>
    </div>
  );
}
